<div class="cp-stage">
    <div class="cp-card">
        <!-- ===== brand side panel ===== -->
        <aside class="cp-side">
            <div class="cp-hero-art">
                <span class="cp-ring r1"></span>
                <span class="cp-ring r2"></span>
                <span class="cp-ring r3"></span>
                <div class="cp-badge"><i class="pi pi-shield"></i></div>
            </div>
            <h3>Account security</h3>
            <p>A strong, unique password keeps your account — and your members' data — safe.</p>
            <ul class="cp-tips">
                <li><i class="pi pi-check-circle"></i> Use 8+ characters</li>
                <li><i class="pi pi-check-circle"></i> Mix letters, numbers &amp; symbols</li>
                <li><i class="pi pi-check-circle"></i> Never reuse an old password</li>
            </ul>
            <div class="cp-signout"><i class="pi pi-sign-out"></i> You'll be signed out after the change.</div>
        </aside>

        <!-- ===== form ===== -->
        <form class="cp-form" [formGroup]="form" (ngSubmit)="submit()">
            <h2>Change <span>Password</span></h2>
            <p class="cp-sub">Pick something strong — you'll use it from your next sign-in.</p>

            <div class="field">
                <label>Current Password</label>
                <p-password formControlName="currentPassword" [toggleMask]="true" [feedback]="false"
                    placeholder="Enter current password" [fluid]="true" />
                @if (form.get('currentPassword')?.touched && form.get('currentPassword')?.invalid) {
                    <small class="err">Current password is required</small>
                }
            </div>

            <div class="field">
                <label>New Password</label>
                <p-password formControlName="newPassword" [toggleMask]="true" [feedback]="false"
                    placeholder="Min 6 characters" [fluid]="true" />

                @if (pwd()) {
                    <div class="cp-meter" [attr.data-score]="strength().score">
                        <span></span><span></span><span></span><span></span>
                    </div>
                    <small class="cp-strength" [style.color]="strength().color">{{ strength().label }}</small>
                }
                @if (form.get('newPassword')?.touched && form.get('newPassword')?.invalid) {
                    <small class="err">New password must be at least 6 characters</small>
                }
                @if (form.errors?.['sameAsOld'] && form.get('newPassword')?.touched) {
                    <small class="err">New password must be different from the current one</small>
                }
            </div>

            <div class="field">
                <label>Confirm New Password</label>
                <p-password formControlName="confirmPassword" [toggleMask]="true" [feedback]="false"
                    placeholder="Re-enter new password" [fluid]="true" />
                @if (form.get('confirmPassword')?.touched && form.errors?.['mismatch']) {
                    <small class="err">Passwords do not match</small>
                }
            </div>

            <!-- live requirements checklist -->
            <ul class="cp-checks">
                <li [class.ok]="checks().len">
                    <i class="pi" [class.pi-check-circle]="checks().len" [class.pi-circle]="!checks().len"></i>
                    At least 6 characters
                </li>
                <li [class.ok]="checks().mix">
                    <i class="pi" [class.pi-check-circle]="checks().mix" [class.pi-circle]="!checks().mix"></i>
                    Letters &amp; numbers
                </li>
                <li [class.ok]="checks().diff">
                    <i class="pi" [class.pi-check-circle]="checks().diff" [class.pi-circle]="!checks().diff"></i>
                    Different from current
                </li>
                <li [class.ok]="checks().match">
                    <i class="pi" [class.pi-check-circle]="checks().match" [class.pi-circle]="!checks().match"></i>
                    Matches confirmation
                </li>
            </ul>

            <p-button type="submit" styleClass="cp-submit" [disabled]="saving()"
                [label]="saving() ? 'Updating...' : 'Change Password'"
                [icon]="saving() ? 'pi pi-spin pi-spinner' : 'pi pi-check'" />
        </form>
    </div>
</div>
